import { render } from "./JobDescriptionHeader.vue?vue&type=template&id=49c92d3e"
import script from "./JobDescriptionHeader.vue?vue&type=script&lang=js"
export * from "./JobDescriptionHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__